import ticketsResponse from './tickets.mock.json'
import thread928096970Response from './928096970.mock.json'
import thread929273706Response from './929273706.mock.json'

const SUPPORTED_THREAD_IDS = [928096970, 929273706, 925981279]

export const MOCK_TICKETS_RESPONSE = ticketsResponse

export const MOCK_THREADS_RAW = (ticketsResponse.data || [])
  .filter(item => SUPPORTED_THREAD_IDS.includes(item.id))

export const MOCK_THREAD_MESSAGES_RAW_BY_ID = {
  928096970: thread928096970Response.data || [],
  929273706: thread929273706Response.data || [],
}
